import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { SnackList_SnackListPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useSnackListQuery = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(SnackList_SnackListPage_Query, {
		variables: {
			hotelID,
		},
	});

	return {
		data,
	};
};
